import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SelectButtonModule } from 'primeng/selectbutton';
import { ClickOutsideDirective } from '../../../shared/directives/click-outside.directive';

@Component({
  selector: 'app-beds-bath-dropdown',
  templateUrl: './beds-bath-dropdown.component.html',
  styleUrls: ['./beds-bath-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,

  imports: [NgClass, ClickOutsideDirective, FontAwesomeModule, SelectButtonModule, FormsModule, ReactiveFormsModule],
})
export class BedsBathDropdownComponent {
  @Input() isMobile = false;
  @Input() numberOfBeds = null;
  @Input() numberOfBaths = null;
  @Input() bedsFormControl?: UntypedFormControl | null = new UntypedFormControl();
  @Input() bathsFormControl?: UntypedFormControl | null = new UntypedFormControl();

  public readonly options = [
    { label: 'Any', value: null },
    { label: '1+', value: 1 },
    { label: '2+', value: 2 },
    { label: '3+', value: 3 },
    { label: '4+', value: 4 },
  ];

  public isOpen = false;
}
